module.exports = __webpack_public_path__ + "static/media/user_feedback.3f1b7d82.png";